const config = {
    apiRootUrl: process.env.REACT_APP_API_ROOT_URL || 'http://192.168.0.11:4001'
}
export default config;